import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    teamNameCell: {
      padding: `0 ${SMALL_MARGIN}px`,
      fontSize: 18,
      lineHeight: 1.4,
      fontWeight: 700,
      width: 'calc(100% - 120px)',
      '& > a': {
        color: colorsPalette.white,
      },
      [theme.breakpoints.up('md')]: {
        maxWidth: '60%',
      },
    },
    teamAmountCell: {
      padding: `0 ${SMALL_MARGIN}px`,
      width: 120,
      [theme.breakpoints.up('md')]: {
        width: 'calc(40% - 46px)',
      },
    },
  }),
);

export default useStyles;
